import { ComponentType } from 'react';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { TextFilterInputs } from '@/components/table/_fieldDefinitions/text/TextFilterInput.tsx';
import { TourPriceArrayFilterInput } from '@/components/table/_fieldDefinitions/tourPriceArray/TourPriceArrayFilterInput.tsx';
import { DateFilterInputs } from '@/components/table/_fieldDefinitions/date/DateFilterInputs.tsx';
import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import { CellContext } from '@tanstack/react-table';
import { dateFieldRender } from '@/components/table/_fieldDefinitions/date/dateFieldRender.tsx';
import { textFieldRender } from '@/components/table/_fieldDefinitions/text/textFieldRender.tsx';
import { numberFieldRender } from '@/components/table/_fieldDefinitions/number/numberFieldRender.tsx';
import { tourPriceArrayFieldRender } from '@/components/table/_fieldDefinitions/tourPriceArray/tourPriceArrayFieldRender.tsx';
import { tourStatusFieldRender } from '@/components/table/_fieldDefinitions/tourStatus/tourStatusFieldRender.tsx';
import { TourStatusFilterInput } from '@/components/table/_fieldDefinitions/tourStatus/TourStatusFilterInput.tsx';
import { DropdownFilterInputs } from '@/components/table/_fieldDefinitions/dropdown/DropdownFilterInputs.tsx';
import { dropdownFieldRender } from '@/components/table/_fieldDefinitions/dropdown/dropdownFieldRender.tsx';
import { CheckboxFilterInputs } from '@/components/table/_fieldDefinitions/checkbox/CheckboxFilterInputs.tsx';
import { checkboxFieldRender } from '@/components/table/_fieldDefinitions/checkbox/checkboxFieldRender.tsx';
import {
  dateExportRender,
  dateTimeExportRender,
  textExportRender,
  checkboxExportRender,
  tourStatusExportRender,
  tourPriceArrayExportRender,
  dropdownExportRender,
  multiselectExportRender,
  moneyValueExportRender,
  nestedClientExportRender,
  nestedTourExportRender,
  nestedBookingExportRender,
  nestedParticipantExportRender,
  nestedWaitlistClientExportRender,
  nestedAppUserExportRender,
  nestedInsuranceExportRender,
  nestedTransportVariantExportRender,
  nestedObjectListExportRender,
  availabilityExportRender,
  dateRangeExportRender,
  nestedInstallmentDetailsExportRender,
  phoneNumberExportRender,
} from '@/components/table/_fieldDefinitions/exportRenders.ts';
import { DateTimeFilterInputs } from '@/components/table/_fieldDefinitions/dateTime/DateTimeFilterInputs.tsx';
import { dateTimeFieldRender } from '@/components/table/_fieldDefinitions/dateTime/dateTimeFieldRender.tsx';
import { MoneyValueFilterInput } from '@/components/table/_fieldDefinitions/moneyValue/MoneyValueFilterInput.tsx';
import { moneyValueFieldRender } from '@/components/table/_fieldDefinitions/moneyValue/moneyValueFieldRender.tsx';
import { MultiselectFilterInputs } from '@/components/table/_fieldDefinitions/multiselect/MultiselectFilterInputs.tsx';
import { multiselectFieldRender } from '@/components/table/_fieldDefinitions/multiselect/multiselectFieldRender.tsx';
import { IdFilterInput } from '@/components/table/_fieldDefinitions/id/IdFilterInput.tsx';
import { idFieldRender } from '@/components/table/_fieldDefinitions/id/idFieldRender.ts';
import { nestedClientFieldRender } from '@/components/table/_fieldDefinitions/nestedClient/nestedClientFieldRender.tsx';
import { nestedTourFieldRender } from '@/components/table/_fieldDefinitions/nestedTour/nestedTourFieldRender.tsx';
import { nestedParticipantFieldRender } from '@/components/table/_fieldDefinitions/nestedParticipant/nestedParticipantFieldRender.tsx';
import { nestedWaitlistClientFieldRender } from '@/components/table/_fieldDefinitions/nestedWaitlistClient/nestedWaitlistClientFieldRender.tsx';
import { nestedAppUserFieldRender } from '@/components/table/_fieldDefinitions/nestedAppUser/nestedAppUserFieldRender.tsx';
import { nestedInsuranceFieldRender } from '@/components/table/_fieldDefinitions/nestedInsurance/nestedInsuranceFieldRender.tsx';
import { NestedInsuranceFilterInputs } from '@/components/table/_fieldDefinitions/nestedInsurance/NestedInsuranceFilterInputs.tsx';
import { nestedTransportVariantFieldRender } from '@/components/table/_fieldDefinitions/nestedTransportVariant/nestedTransportVariantFieldRender.tsx';
import { NestedTransportVariantFilterInputs } from '@/components/table/_fieldDefinitions/nestedTransportVariant/NestedTransportVariantFilterInputs.tsx';
import { nestedObjectListFieldRender } from '@/components/table/_fieldDefinitions/nestedObjectList/nestedObjectListFieldRender.tsx';
import { nestedBookingFieldRender } from '@/components/table/_fieldDefinitions/nestedBooking/nestedBookingFieldRender.tsx';
import { NestedObjectListFilterInputs } from '@/components/table/_fieldDefinitions/nestedObjectList/NestedObjectListFilterInputs.tsx';
import { tourNameFieldRender } from '@/components/table/_fieldDefinitions/tourName/tourNameFieldRender.tsx';
import { availabilityFieldRender } from '@/components/table/_fieldDefinitions/availability/availabilityFieldRender.tsx';
import { dateRangeFieldRender } from '@/components/table/_fieldDefinitions/dateRange/dateRangeFieldRender.tsx';
import { nestedInstallmentDetailsFieldRender } from '@/components/table/_fieldDefinitions/nestedInstallmentDetails/nestedInstallmentDetailsFieldRender.tsx';
import { phoneNumberFieldRender } from '@/components/table/_fieldDefinitions/phoneNumber/phoneNumberFieldRender.tsx';
import { RegistrationModeFilterInput } from '@/components/table/_fieldDefinitions/registrationMode/RegistrationModeFilterInput.tsx';
import { registrationDetailsFieldRender } from '@/components/table/_fieldDefinitions/registrationMode/registrationDetailsFieldRender.tsx';
import {
  registrationModeExportRender,
  enumExportRender,
} from '@/components/table/_fieldDefinitions/exportRenders.ts';
import { EnumFilterInputs } from '@/components/table/_fieldDefinitions/enum/EnumFilterInputs.tsx';
import { enumFieldRender } from '@/components/table/_fieldDefinitions/enum/enumFieldRender.tsx';
import { fileFieldRender } from '@/components/table/_fieldDefinitions/file/fileFieldRender.tsx';
import { fileExportRender } from '@/components/table/_fieldDefinitions/file/fileExportRender.ts';
import { linkOrFileFieldRender } from '@/components/table/_fieldDefinitions/linkOrFile/linkOrFileFieldRender.tsx';
import { linkOrFileExportRender } from '@/components/table/_fieldDefinitions/linkOrFile/linkOrFileExportRender.ts';
import { messageStatusFieldRender } from '@/components/table/_fieldDefinitions/messageStatus/messageStatusFieldRender.tsx';
import { messageStatusExportRender } from '@/components/table/_fieldDefinitions/messageStatus/messageStatusExportRender.ts';
import { TagsFilterInputs } from '@/components/table/_fieldDefinitions/tags/TagsFilterInputs.tsx';
import { tagsFieldRender } from '@/components/table/_fieldDefinitions/tags/tagsFieldRender.tsx';
import { tagsExportRender } from '@/components/table/_fieldDefinitions/tags/tagsExportRender.ts';
import { tourDestinationFieldRender } from '@/components/table/_fieldDefinitions/tourDestination/tourDestinationFieldRender.tsx';
import { tourDestinationExportRender } from '@/components/table/_fieldDefinitions/exportRenders.ts';

/** Wyrównanie kolumny. Domyślnie do lewej — do prawej idą tylko liczby. */
export type FieldAlign = 'left' | 'right';

export interface FieldConfig {
  component: ComponentType<FilterInputProps>;
  fieldCellRender: <T>(
    info: CellContext<T, unknown>,
    customFieldsContext?: unknown,
  ) => unknown;
  exportRender: (value: unknown, customFieldsContext?: unknown) => unknown;
  /**
   * Nagłówek dziedziczy je po typie pola, więc kolumna liczbowa nie rozjeżdża
   * się z własnym tytułem. Cyfry do prawej ustawiają się w pion i rzędy
   * wielkości porównuje się wzrokiem, bez czytania.
   */
  align?: FieldAlign;
}

export const fieldsConfig: Record<FieldType, FieldConfig> = {
  TEXT: {
    component: TextFilterInputs,
    fieldCellRender: textFieldRender,
    exportRender: textExportRender,
  },
  NUMBER: {
    component: TextFilterInputs,
    fieldCellRender: numberFieldRender,
    exportRender: textExportRender,
    align: 'right',
  },
  DATE: {
    component: DateFilterInputs,
    fieldCellRender: dateFieldRender,
    exportRender: dateExportRender,
  },
  TOUR_PRICE_ARRAY: {
    component: TourPriceArrayFilterInput,
    fieldCellRender: tourPriceArrayFieldRender,
    exportRender: tourPriceArrayExportRender,
    align: 'right',
  },
  TOUR_STATUS: {
    component: TourStatusFilterInput,
    fieldCellRender: tourStatusFieldRender,
    exportRender: tourStatusExportRender,
  },
  DROPDOWN: {
    component: DropdownFilterInputs,
    fieldCellRender: dropdownFieldRender,
    exportRender: dropdownExportRender,
  },
  CHECKBOX: {
    component: CheckboxFilterInputs,
    fieldCellRender: checkboxFieldRender,
    exportRender: checkboxExportRender,
  },
  LONG_TEXT: {
    component: TextFilterInputs,
    fieldCellRender: textFieldRender,
    exportRender: textExportRender,
  },
  MULTISELECT: {
    component: MultiselectFilterInputs,
    fieldCellRender: multiselectFieldRender,
    exportRender: multiselectExportRender,
  },
  ID: {
    component: IdFilterInput,
    fieldCellRender: idFieldRender,
    exportRender: textExportRender,
  },
  DATE_TIME: {
    component: DateTimeFilterInputs,
    fieldCellRender: dateTimeFieldRender,
    exportRender: dateTimeExportRender,
  },
  MONEY_VALUE: {
    component: MoneyValueFilterInput,
    fieldCellRender: moneyValueFieldRender,
    exportRender: moneyValueExportRender,
    align: 'right',
  },
  NESTED_CLIENT: {
    component: TextFilterInputs,
    fieldCellRender: nestedClientFieldRender,
    exportRender: nestedClientExportRender,
  },
  NESTED_TOUR: {
    component: TextFilterInputs,
    fieldCellRender: nestedTourFieldRender,
    exportRender: nestedTourExportRender,
  },
  NESTED_PARTICIPANT: {
    component: TextFilterInputs,
    fieldCellRender: nestedParticipantFieldRender,
    exportRender: nestedParticipantExportRender,
  },
  NESTED_INSURANCE: {
    component: NestedInsuranceFilterInputs,
    fieldCellRender: nestedInsuranceFieldRender,
    exportRender: nestedInsuranceExportRender,
  },
  NESTED_TRANSPORT_VARIANT: {
    component: NestedTransportVariantFilterInputs,
    fieldCellRender: nestedTransportVariantFieldRender,
    exportRender: nestedTransportVariantExportRender,
  },
  NESTED_OBJECT_LIST: {
    component: NestedObjectListFilterInputs,
    fieldCellRender: nestedObjectListFieldRender,
    exportRender: nestedObjectListExportRender,
  },
  NESTED_BOOKING: {
    component: TextFilterInputs,
    fieldCellRender: nestedBookingFieldRender,
    exportRender: nestedBookingExportRender,
  },
  NESTED_WAITLIST_CLIENT: {
    component: TextFilterInputs,
    fieldCellRender: nestedWaitlistClientFieldRender,
    exportRender: nestedWaitlistClientExportRender,
  },
  NESTED_APP_USER: {
    component: TextFilterInputs,
    fieldCellRender: nestedAppUserFieldRender,
    exportRender: nestedAppUserExportRender,
  },
  TOUR_NAME: {
    component: TextFilterInputs,
    fieldCellRender: tourNameFieldRender,
    exportRender: textExportRender,
  },
  AVAILABILITY: {
    component: TextFilterInputs,
    fieldCellRender: availabilityFieldRender,
    exportRender: availabilityExportRender,
    align: 'right',
  },
  DATE_RANGE: {
    component: TextFilterInputs,
    fieldCellRender: dateRangeFieldRender,
    exportRender: dateRangeExportRender,
  },
  NESTED_INSTALLMENT_DETAILS: {
    component: TextFilterInputs,
    fieldCellRender: nestedInstallmentDetailsFieldRender,
    exportRender: nestedInstallmentDetailsExportRender,
  },
  PHONE_NUMBER: {
    component: TextFilterInputs,
    fieldCellRender: phoneNumberFieldRender,
    exportRender: phoneNumberExportRender,
  },
  REGISTRATION_DETAILS: {
    component: RegistrationModeFilterInput,
    fieldCellRender: registrationDetailsFieldRender,
    exportRender: registrationModeExportRender,
  },
  ENUM: {
    component: EnumFilterInputs,
    fieldCellRender: enumFieldRender,
    exportRender: enumExportRender,
  },
  FILE: {
    component: TextFilterInputs,
    fieldCellRender: fileFieldRender,
    exportRender: fileExportRender,
  },
  LINK_OR_FILE: {
    component: TextFilterInputs,
    fieldCellRender: linkOrFileFieldRender,
    exportRender: linkOrFileExportRender,
  },
  MESSAGE_STATUS: {
    component: TextFilterInputs,
    fieldCellRender: messageStatusFieldRender,
    exportRender: messageStatusExportRender,
  },
  TAGS: {
    component: TagsFilterInputs,
    fieldCellRender: tagsFieldRender,
    exportRender: tagsExportRender,
  },
  TOUR_DESTINATION: {
    component: TextFilterInputs,
    fieldCellRender: tourDestinationFieldRender,
    exportRender: tourDestinationExportRender,
  },
};
